import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ContentloaderModule } from '@signature-it/ngx-generic/components/contentloader';
import { CartOrdersActionsModuleGeneric } from './actions/actions.module';
import { CartOrdersComponentGeneric } from './orders';
import { OrdersFullLayoutModuleGeneric } from './tmpl/full/full.module';
import { OrdersCheckoutLayoutModuleGeneric } from './tmpl/checkout/checkout.module';
import { ProductImageCartDirectiveModuleGeneric } from '@signature-it/ngx-catalogue/directives';


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        TooltipModule.forRoot(),
        ContentloaderModule,
        ProductImageCartDirectiveModuleGeneric,
        CartOrdersActionsModuleGeneric,
        OrdersFullLayoutModuleGeneric,
        OrdersCheckoutLayoutModuleGeneric
    ],
    exports: [
        CartOrdersComponentGeneric
    ],
    declarations: [
        CartOrdersComponentGeneric]
})
export class CartOrdersModuleGeneric {}
